import { render, staticRenderFns } from "./ProposalCardResponsiveNew.vue?vue&type=template&id=5dd29d76"
import script from "./ProposalCardResponsiveNew.vue?vue&type=script&lang=js"
export * from "./ProposalCardResponsiveNew.vue?vue&type=script&lang=js"
import style0 from "./ProposalCardResponsiveNew.vue?vue&type=style&index=0&id=5dd29d76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports